// Mock data for ConstructHelp platform

export const mockWorkers = [
  {
    id: '1',
    name: 'Mike Rodriguez',
    title: 'Master Electrician',
    location: 'Los Angeles, CA',
    hourlyRate: '$65-85',
    rating: 4.9,
    reviews: 47,
    experience: '15+ years',
    skills: ['Electrical', 'Wiring', 'Panel Installation', 'Troubleshooting'],
    image: 'https://ui-avatars.com/api/?name=Mike+Rodriguez&size=150&background=f97316&color=fff&bold=true'
  },
  {
    id: '2',
    name: 'Sarah Johnson',
    title: 'Plumbing Contractor',
    location: 'Phoenix, AZ',
    hourlyRate: '$55-75',
    rating: 4.8,
    reviews: 32,
    experience: '12+ years',
    skills: ['Plumbing', 'Pipe Installation', 'Water Heaters', 'Drainage'],
    image: 'https://ui-avatars.com/api/?name=Sarah+Johnson&size=150&background=3b82f6&color=fff&bold=true'
  },
  {
    id: '3',
    name: 'Carlos Martinez',
    title: 'Framing Specialist',
    location: 'Austin, TX',
    hourlyRate: '$45-65',
    rating: 4.9,
    reviews: 58,
    experience: '20+ years',
    skills: ['Framing', 'Carpentry', 'Drywall', 'Roofing'],
    image: 'https://ui-avatars.com/api/?name=Carlos+Martinez&size=150&background=10b981&color=fff&bold=true'
  },
  {
    id: '4',
    name: 'Jennifer Lee',
    title: 'HVAC Technician',
    location: 'Denver, CO',
    hourlyRate: '$50-70',
    rating: 4.7,
    reviews: 29,
    experience: '8+ years',
    skills: ['HVAC', 'Air Conditioning', 'Heating Systems', 'Ventilation'],
    image: 'https://ui-avatars.com/api/?name=Jennifer+Lee&size=150&background=8b5cf6&color=fff&bold=true'
  },
  {
    id: '5',
    name: 'David Thompson',
    title: 'General Contractor',
    location: 'Seattle, WA',
    hourlyRate: '$75-95',
    rating: 4.9,
    reviews: 73,
    experience: '25+ years',
    skills: ['Project Management', 'Construction', 'Renovations', 'Permits'],
    image: 'https://ui-avatars.com/api/?name=David+Thompson&size=150&background=ef4444&color=fff&bold=true'
  },
  {
    id: '6',
    name: 'Amanda Foster',
    title: 'Tile & Flooring Expert',
    location: 'Miami, FL',
    hourlyRate: '$40-60',
    rating: 4.8,
    reviews: 41,
    experience: '10+ years',
    skills: ['Tile Installation', 'Hardwood', 'Laminate', 'Bathroom Remodel'],
    image: 'https://ui-avatars.com/api/?name=Amanda+Foster&size=150&background=ec4899&color=fff&bold=true'
  }
];

export const mockJobs = [
  {
    id: '1',
    title: 'Residential Electrical Work',
    company: 'HomeBuilders Inc.',
    location: 'Los Angeles, CA',
    budget: '$5,000 - $7,000',
    duration: '2 weeks',
    postedDate: '2 days ago',
    description: 'Need licensed electrician for complete house rewiring project',
    skills: ['Electrical', 'Wiring', 'Code Compliance'],
    applications: 12
  },
  {
    id: '2',
    title: 'Commercial HVAC Installation',
    company: 'CoolAir Systems',
    location: 'Phoenix, AZ',
    budget: '$15,000 - $20,000',
    duration: '1 month',
    postedDate: '5 days ago',
    description: 'Installation of commercial HVAC system in new office building',
    skills: ['HVAC', 'Commercial', 'Installation'],
    applications: 8
  },
  {
    id: '3',
    title: 'Kitchen Renovation',
    company: 'Modern Homes LLC',
    location: 'Austin, TX',
    budget: '$10,000 - $15,000',
    duration: '3 weeks',
    postedDate: '1 week ago',
    description: 'Complete kitchen remodel including plumbing and electrical',
    skills: ['Carpentry', 'Plumbing', 'Electrical', 'Tile'],
    applications: 15
  }
];

export const mockProjects = [
  {
    id: '1',
    title: 'Downtown Office Complex',
    status: 'On Track',
    progress: 85,
    dueDate: 'Dec 15, 2024',
    crew: 12,
    budget: '$250,000'
  },
  {
    id: '2',
    title: 'Residential Renovation',
    status: 'In Progress',
    progress: 67,
    dueDate: 'Jan 20, 2025',
    crew: 8,
    budget: '$85,000'
  },
  {
    id: '3',
    title: 'Commercial Warehouse',
    status: 'Finishing',
    progress: 92,
    dueDate: 'Nov 30, 2024',
    crew: 15,
    budget: '$500,000'
  },
  {
    id: '4',
    title: 'School Building Repair',
    status: 'Delayed',
    progress: 45,
    dueDate: 'Feb 28, 2025',
    crew: 6,
    budget: '$120,000'
  }
];

export const mockActivities = [
  {
    id: '1',
    message: 'Payment approved for Downtown Office Project',
    time: '2 hours ago'
  },
  {
    id: '2',
    message: 'John Smith added to Warehouse Construction crew',
    time: '4 hours ago'
  },
  {
    id: '3',
    message: 'Shopping Mall Phase 2 marked as completed',
    time: '1 day ago'
  },
  {
    id: '4',
    message: '3 crew licenses expiring in 30 days',
    time: '2 days ago'
  }
];

export const mockStats = {
  activeProjects: { value: 24, change: '+12%' },
  completedThisMonth: { value: 8, change: '+25%' },
  avgCompletion: { value: '94%', change: '+5%' },
  onTimeDelivery: { value: '96%', change: '+8%' }
};

export const mockDashboardStats = {
  activeProjects: { value: 8, info: '+2 this week' },
  totalCrew: { value: 24, info: '3 available today' },
  monthRevenue: { value: '$47,500', info: '+12% from last month' },
  completionRate: { value: '94%', info: 'Above average' }
};
